import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-social-media-row',
  templateUrl: './footer-social-media-row.component.html',
  styleUrls: ['./footer-social-media-row.component.scss']
})
export class FooterSocialMediaRowComponent implements OnInit {
  public currYear: number;
  constructor() { }

  ngOnInit(): void {
    const date = new Date();
    this.currYear = date.getFullYear();
  }

}
